<template>
  <div class="m-common__review__images" id="base-review-image-thumbs">
    <ul v-if="images.length !== 0" class="photoswipeGroup">
      <li class="photoswipeImages" v-for="(image, index) in images" :key="String(reviewId) + String(index)" v-if="index < maxImageSize">
        <span :data-src="image.path" data-size=""><img :src="image.path" alt=""></span>
      </li>
    </ul>
    <p v-if="isRenderImagesPageLink && this.images.length !== 0"><a :href="reviewImageUrl">投稿された画像をすべて見る</a></p>
  </div>
</template>

<script>
import urls from '@/mixins/urls'
export default {
  name: 'BaseReviewImageThumbs',
  mixins: [ urls ],
  props: {
    skuCode: {
      type: String,
      required: true
    },
    images: {
      type: Array,
      default: []
    },
    isRenderImagesPageLink: {
      type: Boolean,
      default: false
    },
    reviewId: {
      type: Number,
      default: 1
    },
    maxImageSize: {
      type: Number,
      default: 5
    }
  },
  computed: {
    reviewImageUrl () {
      return this.getReviewImageUrl(this.skuCode)
    }
  },
  mounted () {
    this.initializePhotoSwipe()
  },
  updated () {
    this.initializePhotoSwipe()
  },
  methods: {
    initializePhotoSwipe () {
      if (window.$) {
        const $ = window.$
        const vm = this
        $(window).on('resize.' + this.reviewId, function () {
          $('.photoswipeImages [data-src]', vm.$el).each(function () {
            const $src = $(this)
            $src.height($src.width())
          })
        })
        const $srcs = $('.photoswipeImages [data-src]', vm.$el)
        let count = $srcs.length
        $srcs.find('img').off('load.hoge').on('load.hoge', function () {
          const $img = $(this)
          const $src = $img.parent('[data-src]')
          $src.height($src.width())
          const w = this.naturalWidth
          const h = this.naturalHeight
          if (w > h) {
            $img.addClass('fit-height')
          } else if (w < h) {
            $img.addClass('fit-width')
          }
          if (--count === 0) {
            $('.pswp').remove()
            window.initPhotoSwipeFromDOM('.photoswipeGroup', '.photoswipeImages')
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BaseReviewImageThumbs.vue